import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bg-white rounded-lg p-4 border-gray-200 text-left text-gray-800 mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg mb-4" }, "Período a filtrar", -1)
const _hoisted_4 = { class: "flex flex-col mb-5" }
const _hoisted_5 = { class: "flex justify-between gap-3" }

import { ref } from 'vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { DatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import { mdiCalendarBlankOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterHistory',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ['close', 'apply-filters'],
  setup(__props: any, { emit }) {





const startDate = ref<Date | null>(null)
const endDate = ref<Date | null>(null)

const applyFilters = () => {
  emit('apply-filters', {
    startDate: startDate.value,
    endDate: endDate.value
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(DatePicker), {
              modelValue: startDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
              masks: { modelValue: 'YYYY-MM-DD', input: 'DD/MM/YYYY' },
              "is-required": ""
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createVNode(_component_v_text_field, _mergeProps({
                  label: "Data inicial",
                  "model-value": inputValue
                }, _toHandlers(inputEvents), {
                  class: "w-full",
                  color: "primary20",
                  variant: "outlined",
                  density: "comfortable",
                  "append-inner-icon": _unref(mdiCalendarBlankOutline)
                }), null, 16, ["model-value", "append-inner-icon"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_unref(DatePicker), {
              modelValue: endDate.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
              locale: "pt-BR",
              masks: { modelValue: 'YYYY-MM-DD', input: 'DD/MM/YYYY' }
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createVNode(_component_v_text_field, _mergeProps({
                  label: "Data final",
                  "model-value": inputValue
                }, _toHandlers(inputEvents), {
                  class: "w-full",
                  color: "primary20",
                  variant: "outlined",
                  density: "comfortable",
                  "append-inner-icon": _unref(mdiCalendarBlankOutline)
                }), null, 16, ["model-value", "append-inner-icon"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(OutlineButton, {
              text: "Cancelar",
              color: "primary30",
              height: "40px",
              width: "120px",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
            }),
            _createVNode(FilledButton, {
              text: "Aplicar filtros",
              color: "primary30",
              height: "40px",
              width: "160px",
              class: "bg-primary30",
              onClick: applyFilters
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})